import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { legalApi } from './api';
import { DATA_CONTROLLER_ACK } from './documents';
import { LegalAcceptanceModal } from './LegalAcceptanceModal';

/**
 * PRD §13.3 — first-login Data Controller Ack gate.
 *
 * Mounts inside AdminShell. On every page load it asks the backend
 * "has this user accepted the current DCA versionHash?". If null, renders
 * the modal until acceptance lands; once accepted, refetch returns the
 * row and the modal stops rendering.
 *
 * Other modals (DPA, TCPA, Reporter Terms) are contextual — they trigger
 * from the relevant page (billing flow, marketing toggle, reporter link)
 * rather than the global shell.
 */
export function LegalGate() {
  const [dismissed, setDismissed] = useState(false);
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['legal-acceptance', DATA_CONTROLLER_ACK.type, DATA_CONTROLLER_ACK.versionHash],
    queryFn: () =>
      legalApi.check(DATA_CONTROLLER_ACK.type, DATA_CONTROLLER_ACK.versionHash),
    // Cache for the session — re-checks are cheap but rendering is gated on
    // the result so cap stale-time at zero to avoid a flash of modal on
    // re-mount after acceptance.
    staleTime: 0,
    retry: false,
  });

  if (isLoading) return null;
  if (data) return null;
  if (dismissed) return null;

  return (
    <LegalAcceptanceModal
      document={DATA_CONTROLLER_ACK}
      onDone={() => {
        refetch();
        setDismissed(true);
      }}
    />
  );
}
